import type {Warehouse} from "./types";

export const parseWarehouse: Warehouse = (datum, language) => {
	if (!datum) return;
	return {
		id: datum.get('id'),
		address: datum.getIn(['description', language])
	}
}